import { render, staticRenderFns } from "./PrivacyBanner.vue?vue&type=template&id=3d1739ba&scoped=true"
import script from "./PrivacyBanner.vue?vue&type=script&lang=ts"
export * from "./PrivacyBanner.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyBanner.vue?vue&type=style&index=0&id=3d1739ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1739ba",
  null
  
)

export default component.exports